import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

export const HelperText = styled(Typography)(() => ({
  fontSize: "12px",
  maxWidth: "593px",
  lineHeight: "20px",
}));
